import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	files: {},
	selectedFile: {},
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadFiles(state, files) {
			state.files = JSON.parse(JSON.stringify(files));
		},
		setSelectedFile(state, sf) {
			state.selectedFile = JSON.parse(JSON.stringify(sf));
		},
		refreshListEmitter() {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getFiles: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.AI_META_MAP_LIST,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						commit('loadFiles', data.files);
						return data;
					} else {
						fail(data.message || 'Failed to load AI Meta Map files');
						return false;
					}
				})
				.catch(err => {
					fail(err.toString() || 'Failed to load AI Meta Map files');
				});
		},
		getExtractedData: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.AI_META_MAP_EXTRACTED_DATA,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					fail(err.toString() || 'Failed to load extracted data');
				});
		},
		extractFile: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.AI_META_MAP_EXTRACT,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return true;
					} else {
						fail(data.message || 'Failed to extract file');
						return false;
					}
				})
				.catch(err => {
					fail(err.toString() || 'Failed to extract file');
				});
		},
		rejectFile: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.AI_META_MAP_REJECT,
				},
				{ root: true }
			)
				.then(data => {
					if (data.ok) {
						return true;
					} else {
						fail(data.message || 'Failed to reject file');
						return false;
					}
				})
				.catch(err => {
					fail(err.toString() || 'Failed to reject file');
				});
		},
		getFileMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.AI_META_MAP_FILE_META,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					fail(err.toString() || 'Failed to load AI file meta');
				});
		},
		getFileJSON: ({ commit, dispatch }, { renderMode, filePathURL }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {},
					url:
						renderMode == 'parsed'
							? constants.UTILITY_PARSED_FILE + filePathURL
							: constants.UTILITY_TRANSFORMED_FILE + filePathURL,
				},
				{ root: true }
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					fail(err.toString() || 'Failed to load file JSON');
				});
		},
		downloadFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.filename.split('.')[0],
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.filename);
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download file');
				});
		},
		downloadActualFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.originalFilename.split('.')[0],
					responseType: 'blob',
				},
				{ root: true }
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{ text: 'Starting Download' },
							{ root: true }
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.originalFilename);
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{ text: 'Could not start download' },
							{ root: true }
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					commit(
						'openSnackbar',
						{ text: 'Could not start download' },
						{ root: true }
					);
					fail(err.toString() || 'Failed to Download file');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		files: state => state.files,
		selectedFile: state => state.selectedFile,
	},
};
